import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import ThemeProvider from './theme/ThemeProvider';
import FreeWheelPage from './pages/FreeWheelPage';
import NewPaidRoulettePage from './pages/NewPaidRoulettePage';
import SpinHistoryPage from './pages/SpinHistoryPage';
import BuyBonusPage from './pages/BuyBonusPage';

// Import context providers
import { UserProvider } from './contexts/UserContext';
import { SpinRewardsProvider } from './contexts/SpinRewardsContext';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <UserProvider>
        <SpinRewardsProvider>
          <Router>
            <Routes>
              <Route path="/free-wheel" element={<FreeWheelPage />} />
              <Route path="/paid-roulette" element={<NewPaidRoulettePage />} />
              <Route path="/bonus" element={<BuyBonusPage />} />
              <Route path="/spin-history" element={<SpinHistoryPage />} />
              <Route path="/" element={<Navigate to="/paid-roulette" replace />} />
            </Routes>
          </Router>
        </SpinRewardsProvider>
      </UserProvider>
    </ThemeProvider>
  );
};

export default App;
